import type { RootState } from '@app/store';

export const selectRecordModal = ({ recordModal }: RootState) => recordModal;

export const selectRecordCreationContext = ({ recordModal }: RootState) =>
  recordModal.creationContext;
